var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M277.9,31.2c-3.3-12.3-12.9-22-25.1-25.3c-22.1-6-110.9-6-110.9-6S53.2,0,31,6C18.8,9.3,9.2,18.9,5.9,31.2\r\n\tC0,53.5,0,100,0,100s0,46.5,5.9,68.8c3.3,12.3,12.9,22,25.1,25.3c22.1,6,110.9,6,110.9,6s88.8,0,110.9-6c12.2-3.3,21.8-13,25.1-25.3\r\n\tc5.9-22.3,5.9-68.8,5.9-68.8S283.9,53.5,277.9,31.2z M112.9,142.2V57.8l74.2,42.2L112.9,142.2z"}));
}

Youtube.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"283.9px","height":"200px","viewBox":"0 0 283.9 200","style":{"enableBackground":"new 0 0 283.9 200"},"xmlSpace":"preserve"};

module.exports = Youtube;

Youtube.default = Youtube;
